import { render, staticRenderFns } from "./recommendCom.vue?vue&type=template&id=78adc5e0&scoped=true&"
import script from "./recommendCom.vue?vue&type=script&lang=ts&"
export * from "./recommendCom.vue?vue&type=script&lang=ts&"
import style0 from "./recommendCom.vue?vue&type=style&index=0&id=78adc5e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78adc5e0",
  null
  
)

export default component.exports